import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=5c2a8ed1&"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts&"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2a8ed1')) {
      api.createRecord('5c2a8ed1', component.options)
    } else {
      api.reload('5c2a8ed1', component.options)
    }
    module.hot.accept("./LoadingComponent.vue?vue&type=template&id=5c2a8ed1&", function () {
      api.rerender('5c2a8ed1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingComponent.vue"
export default component.exports